import { chatStep01, chatStep02, chatStep03, connectIcon, reachIcon, searchIcon } from '../../images';

export const bmoData = [
  {
    icon: searchIcon,
    desc: 'Search for People & Products in the design industry',
  },
  {
    icon: reachIcon,
    desc: 'Stay updated on Art & Design events near you',
  },
];

export const bmoAISteps = [
  {
    icon: chatStep01,
    title: 'STEP O1',
    desc: 'Chat on WhatsApp',
  },
  {
    icon: chatStep02,
    title: 'STEP O2',
    desc: 'Ask anything',
  },
  {
    icon: chatStep03,
    title: 'STEP O3',
    desc: 'Get answers & contacts',
  },
];
